// extracted by mini-css-extract-plugin
export default {"InputComponent":"Input_InputComponent__-P-Bn","InputClosedStyle":"Input_InputClosedStyle__LUu00","InputStyles":"Input_InputStyles__sWZQj","label":"Input_label__pAcsV"};